import PropTypes from 'prop-types';

const dataToPropPropType = PropTypes.objectOf(PropTypes.string);

export default dataToPropPropType;
